import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.209 17.504a.75.75 0 0 1 .021-1.06l3.938-3.709L9.23 9.026a.75.75 0 0 1-.021-1.06.75.75 0 0 1 1.06-.021l4.5 4.25a.75.75 0 0 1 0 1.082l-4.5 4.25a.75.75 0 0 1-1.06-.021z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const MenuRightIcon = ForwardRef;